import { render, staticRenderFns } from "./view-asset.vue?vue&type=template&id=f63d0804&scoped=true&"
import script from "./view-asset.vue?vue&type=script&lang=ts&"
export * from "./view-asset.vue?vue&type=script&lang=ts&"
import style0 from "./view-asset.vue?vue&type=style&index=0&id=f63d0804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d0804",
  null
  
)

export default component.exports